import { ApiError } from '../errors/api-error.js';

export class TenantOnboardingApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/tenant-onboarding';
    }
    async onboard(config) {
        try { return (await this.client.post(this.basePath, config)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
}
